import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'

const select = {
  kt: tools.equals(fields.central, 1),
  ktr: tools.equals(fields.removed, 1)
}

export default {
  select: select,

  present: tools.cfg.list(
    fields.central, 'Cathéter central présent', go.fields.yesNoUnknown, {
      tt: `Taper le chiffre ou les premières lettres du choix.
Pour clore la liste ou supprimer une entrée, sélectionner «2. Non» ou
«9. Non Connu».`,
      pop: tools.not(select.kt)
    }
  ),

  insertionDate: tools.cfg.date(
    fields.insertion, 'de pose', { op: true }
  ),

  removed: tools.cfg.list(
    fields.removed, 'Retrait du cathéter', go.fields.yesNoUnknown
  ),

  removalDate: tools.cfg.date(
    fields.removal, 'de retrait du cathéter', {
      tt: 'jj/mm/aaaa, postérieure à la date de pose.'
    }
  ),

  labo: (function () {
    const f = fields.laboratory
    const t = 'Envoi au laboratoire'
    return {
      v1: tools.cfg.list(f, t, go.fields2019.labo),
      v2: tools.cfg.list(f, t, go.fields.yesNoUnknown)
    }
  })()
}
